module.exports = __webpack_public_path__ + "img/home-top-bg.659f24d9.png";